import { useEffect, useState } from "react";

export function useCountUp(to: number, duration = 700, deps: any[] = []) {
  const [val, setVal] = useState(0);
  const [done, setDone] = useState(false);

  useEffect(() => {
    const start = performance.now();
    const from = 0;
    const step = (t: number) => {
      const p = Math.min(1, (t - start) / duration);
      const eased = 1 - Math.pow(1 - p, 3);
      setVal(from + (to - from) * eased);
      if (p < 1) requestAnimationFrame(step);
      else setDone(true);
    };
    setVal(0);
    setDone(false);
    const r = requestAnimationFrame(step);
    return () => cancelAnimationFrame(r);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);

  return { val, done };
}
